import axios from "axios";
import { useEffect, useState } from "react";

const useAxios = (endPoint) => {
	let baseUrl = window.origin;
	let reqUrl = `${baseUrl}/wp-json/cne/v1/${endPoint}`;
	const [response, setResponse] = useState([]);

	useEffect(() => {
		const getResponse = async () => {
			try {
				const { data } = await axios.get(reqUrl);
				if (data.length) {
					setResponse([...data]);
				} else {
					setResponse([]);
				}
			} catch (error) {
				throw new Error('Api request failed', { cause: error });
			}
		};
		getResponse();
	}, [endPoint]);

	return response;
};

export default useAxios;
